/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Determines if an item should be reachable in non-linear restricted navigation mode.
 * Item is only unreachable if not yet viewed and the item before it also not yet viewed.
 * This approach works because the testMap items are always kept up-to-date by qti.js.
 *
 * @param {Object} item - Item object cloned from latest testMap
 * @param {Object[]} testPartItems - all items in this part
 * @returns {Boolean}
 */
export function isItemReachable(item, testPartItems) {
    if (item.viewed) {
        return true;
    }
    const prevItem = testPartItems.find(itm => itm.position === item.position - 1);
    if (prevItem && prevItem.viewed) {
        return true;
    }
    return false;
}
